/* eslint-disable import/prefer-default-export */
import { tagsUrl } from '../urls';
import refresh from '../refresh';

export async function getTags() {
  return refresh(async () => {
    const response = await fetch(tagsUrl, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    });
    return response;
  });
}
